import React, { type ReactNode, useMemo } from 'react';
import type { PartialBy } from '@types';
import { SliderContext, type SliderContextValues } from './context';
import Header from './Header';
import Footer from './Footer';
import Control from './Control';
import Bar from './Bar';

interface Props
  extends PartialBy<SliderContextValues, 'valToString' | 'value'> {
  disabled?: boolean;
  className?: string;
  children: ReactNode;
}

function Slider({
  className,
  children,
  min,
  max,
  value = min,
  scheme = 'dark',
  valToString = String,
  disabled,
  onChange,
}: Props) {
  const contextValue = useMemo(
    () => ({
      min,
      max,
      value,
      scheme,
      valToString,
      onChange: (val: number) => {
        if (!disabled) {
          onChange(val);
        }
      },
    }),
    [min, max, value, valToString, onChange, disabled, scheme]
  );
  return (
    <SliderContext.Provider value={contextValue}>
      <div className={className}>{children}</div>
    </SliderContext.Provider>
  );
}

Slider.Header = Header;
Slider.Bar = Bar;
Slider.Footer = Footer;
Slider.Control = Control;

export default Slider;
